module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/3490cc759e1a3f0380461dba72a73a6b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_tick_checkbox.svg
// module id = 1uEC
// module chunks = 1